module.exports = __webpack_public_path__ + "img/oneOrange.5948f111.jpg";